module.exports = __webpack_public_path__ + "img/download-1-INTphone.f3583f0c.png";